import React from "react";
import theme from "../../theme/material-ui-theme";
import {
  ContentListImageWrapper,
  CustomArrowForward,
  CustomColoredDiv,
  CustomCtaText,
  CustomLocalizedLink,
  CustomTitleText
} from "./styles";
import { Box, Hidden, Typography } from "@material-ui/core";

interface CardProps {
  item: {
    title: string | null;
    titlePrefix: string | null;
    cta: string | null;
    link: string | null;
    image: {
      url: string | null;
    };
  };
}

export const ContentCard: React.FunctionComponent<CardProps> = ({
  item: {
    title,
    titlePrefix,
    cta,
    link,
    image: { url }
  }
}) => (
  <CustomLocalizedLink to={link}>
    <Box
      display="flex"
      flexDirection="column"
      border={1}
      borderColor="#DDD9D2"
      borderRadius="3px"
      height={{ xs: "320px", md: "488px" }}
      width={{ xs: "166px", md: "304px" }}
    >
      <ContentListImageWrapper
        src={url}
        imgixParams={{ auto: "format,compress" }}
      />
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        padding={{ xs: "10px 0 0 12px", md: "13px 20px 0" }}
        height={{ xs: "151px", md: "177px" }} //Safari not picking up height
      >
        <Box>
          <Box
            fontSize={{ xs: "1.1rem", md: "1.4rem" }}
            lineHeight="1.6rem"
            fontFamily="Roobert"
            color={theme.palette.grey[600]}
          >
            <Hidden implementation="css" smDown>
              <Typography variant="body2">{titlePrefix}</Typography>
            </Hidden>
            <Hidden implementation="css" mdUp>
              <Typography variant="caption">{titlePrefix}</Typography>
            </Hidden>
          </Box>
          <Box padding={{ xs: "5px 0", md: "5px 0 13px 0" }}>
            <Hidden implementation="css" smDown>
              <Typography variant="h6">{title}</Typography>
            </Hidden>
            <Hidden implementation="css" mdUp>
              <CustomTitleText>{title}</CustomTitleText>
            </Hidden>
          </Box>
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          borderTop={1}
          color="#EAE5DD"
          marginLeft={{ xs: -1.5, md: 0 }}
        >
          <Box
            padding={{ xs: "7px 0 5px 0", md: "10px 0 12px 0" }}
            color="#1E1E1E"
            paddingLeft={{ xs: 1.5, md: 0 }}
          >
            <Hidden implementation="css" smDown>
              <CustomCtaText>{cta}</CustomCtaText>
            </Hidden>
            <Hidden implementation="css" mdUp>
              <Typography variant="caption">{cta}</Typography>
            </Hidden>
          </Box>
          <CustomArrowForward />
        </Box>
      </Box>
      <CustomColoredDiv />
    </Box>
  </CustomLocalizedLink>
);
